import { createAction } from '@reduxjs/toolkit'

export const changePage = createAction<number>('changePage')
export const resetPagination = createAction('resetPage')
